import type { PublishableQuickCreateValues } from './values.ts'

export const mapQuickCreateToPublishedLoad = (values: PublishableQuickCreateValues) => {
  const payload = {
    company_id: values.company_id,
    drops: values.drops.map((drop, order) => {
      const { location_id, ...place } = drop.place

      return {
        date: drop.date,
        location_id,
        order,
        place: { ...place, country: place.country ?? '', country_code: place.country_code ?? '' },
        reference_no: drop.reference_no ?? null,
        time: drop.time,
        type: drop.type,
      }
    }),
    end_customer_company_id: values.end_customer_company_id,
    end_customer_contact_id: null,
    goods_description: null,
    load_type_id: values.load_type_id,
    notes: values.notes ?? null,
    organisation_id: values.organisation_id,
    packaging_type_id: undefined,
    pallets: undefined,
    requirements: { adr: false, dvs: false, waste_license: false },
    // SAFETY: this flow always publishes a quick-created load to cover.
    status: 'to_cover' as const,
    user_id: values.user_id,
    weight: values.weight,
    weight_unit: values.weight_unit,
  }

  return values.customer_rate
    ? {
        ...payload,
        customer_rate: {
          amount: Math.round(values.customer_rate.amount * 100),
          currency: values.customer_rate.currency,
        },
      }
    : payload
}
